import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  hideAddedItemNotification,
  openCart,
  selectAddedItemNotification,
} from '../../store/slices/cartSlice'
import styles from './AddToCartNotification.module.css'

const AddToCartNotification = () => {
  const dispatch = useDispatch()
  const notification = useSelector(selectAddedItemNotification)
  const [isHiding, setIsHiding] = useState(false)

  // Ефект для автоматичного приховування повідомлення
  useEffect(() => {
    if (notification.show) {
      const timer = setTimeout(() => {
        setIsHiding(true)
        setTimeout(() => {
          dispatch(hideAddedItemNotification())
          setIsHiding(false)
        }, 300) // Час анімації зникнення
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [notification.show, dispatch])

  const handleCloseNotification = useCallback(() => {
    setIsHiding(true)
    setTimeout(() => {
      dispatch(hideAddedItemNotification())
      setIsHiding(false)
    }, 300) // Час анімації зникнення
  }, [dispatch])

  const handleViewCart = useCallback(() => {
    dispatch(openCart())
    setIsHiding(true)
    setTimeout(() => {
      dispatch(hideAddedItemNotification())
      setIsHiding(false)
    }, 300) // Час анімації зникнення
  }, [dispatch])

  if (!notification.show || !notification.item) {
    return null
  }

  return (
    <div className={`${styles.addToCartNotification} ${isHiding ? styles.hiding : ''}`}>
      <button
        className={styles.closeButton}
        onClick={e => {
          e.stopPropagation()
          handleCloseNotification()
        }}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.666016"
            y="0.666504"
            width="16.6667"
            height="16.6667"
            rx="4.16667"
            stroke="#BFBFBF"
            strokeWidth="1.25"
          />
          <path
            d="M7.23204 10.768L10.7676 7.23242"
            stroke="#BFBFBF"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.23204 7.23253L10.7676 10.7681"
            stroke="#BFBFBF"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <div className={styles.addToCartIcon}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path d="M18 15H7L5.5 6H21L18 15Z" fill="#8BCB00" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 3C2 2.44772 2.44772 2 3 2H5C5.48884 2 5.90603 2.35341 5.98639 2.8356L6.34713 5H21C21.3214 5 21.6233 5.15452 21.8112 5.41529C21.9992 5.67606 22.0503 6.01128 21.9487 6.31623L18.9487 15.3162C18.8126 15.7246 18.4304 16 18 16H7C6.51116 16 6.09397 15.6466 6.01361 15.1644L4.15287 4H3C2.44772 4 2 3.55228 2 3ZM6.68046 7L7.84713 14H17.2792L19.6126 7H6.68046Z"
            fill="#8BCB00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 20C6 18.8954 6.89543 18 8 18C9.10457 18 10 18.8954 10 20C10 21.1046 9.10457 22 8 22C6.89543 22 6 21.1046 6 20Z"
            fill="#8BCB00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 20C15 18.8954 15.8954 18 17 18C18.1046 18 19 18.8954 19 20C19 21.1046 18.1046 22 17 22C15.8954 22 15 21.1046 15 20Z"
            fill="#8BCB00"
          />
        </svg>
      </div>
      <div className={styles.addToCartText}>
        <span className={styles.addToCartTitle}>{notification.item.name} додано до кошика</span>
        <button
          className={styles.addToCartButton}
          onClick={e => {
            e.stopPropagation()
            handleViewCart()
          }}
        >
          Переглянути
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="9"
            height="15"
            viewBox="0 0 9 15"
            fill="none"
          >
            <path
              d="M1.1665 0.5V0.5C1.1665 4.36283 4.30344 7.49908 8.16625 7.48872V7.48872"
              stroke="#FF7000"
              strokeWidth="1.5"
            />
            <path
              d="M1.1665 14.5V14.5C1.1665 10.6372 4.30344 7.50092 8.16625 7.51128V7.51128"
              stroke="#FF7000"
              strokeWidth="1.5"
            />
          </svg>
        </button>
      </div>
      <div className={styles.addToCartArrow}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M6 4L10 8L6 12"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  )
}

export default AddToCartNotification
